module.exports = __webpack_public_path__ + "img/linkedin-logo.8d601405.svg";